import { RichEdit } from 'devexpress-richedit';

export const exportToBase64 = (richEdit: RichEdit): Promise<string> => {
	return new Promise((resolve, reject) => {
		richEdit.exportToBase64((content: string) => {
			resolve(content);
		});
	});
};
